import { render, staticRenderFns } from "./FaceFeatures.vue?vue&type=template&id=53a530ab&scoped=true"
import script from "./FaceFeatures.vue?vue&type=script&lang=js"
export * from "./FaceFeatures.vue?vue&type=script&lang=js"
import style0 from "./FaceFeatures.vue?vue&type=style&index=0&id=53a530ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a530ab",
  null
  
)

export default component.exports